import React, { useEffect } from 'react';

export default function useScrollIntoView(offset = 0) {
    const scrollElementRef = React.useRef(null);
    useEffect(
        function scrollActiveLeft() {
            if (scrollElementRef.current) {
                scrollElementRef.current.parentElement.scrollLeft = scrollElementRef.current.offsetLeft - offset;
            }
        },
        [offset]
    );
    return scrollElementRef;
}
